import type { PriceValue } from "@anaconda/core/price/types"
import Big from "big.js"
import { formatPrice } from "./utils"

/** A price's USD value, when its currency has a rate. Plain function, not a hook. */
export const toUsdPrice = (value: PriceValue) => {
  if (!value.currency.usdExchangeRate) return undefined

  return Big(value.amount).times(value.currency.usdExchangeRate).toNumber()
}

export const useUsdPrice = (value: PriceValue) => toUsdPrice(value)

export const useFormattedUsdPrice = (value: PriceValue) => {
  const priceInUsd = useUsdPrice(value)

  return priceInUsd && formatPrice(priceInUsd)
}
